<template>
  <div>
    <Contenedor
      :datos="datos"
      :datosEnabled="datosEnabled"
      widthCard="200px"
      @openURL="openURL"
    />
  </div>
</template>

<script>
import Contenedor from './Contenedor.vue';

export default {
  props: {
    datos: Object,
    datosEnabled: Number
  },
  components: {
    Contenedor
  },
  methods: {
    openURL (item) {
      if (this.datosEnabled === -1) return;

      const name = item.name;

      if (name === 'Objetivos de desarrollo sostenible') {
        this.$router.push({ name: 'ods' });
      } else if (name === 'Agenda urbana española') {
        this.$router.push({ name: 'vista-general' });
      } else if (name === 'Iddigo') {
        window.open('https://iddigo.com/login', '_blank');
      }
    }
  }
};
</script>
